import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const YoutubeIcon: React.FC<SvgProps> = ({ color, ...props }) => {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        id="Vector"
        d="M10 15.353L15.19 12.353L10 9.35303V15.353ZM21.56 7.52303C21.69 7.99303 21.78 8.62303 21.84 9.42303C21.91 10.223 21.94 10.913 21.94 11.513L22 12.353C22 14.543 21.84 16.153 21.56 17.183C21.31 18.083 20.73 18.663 19.83 18.913C19.36 19.043 18.5 19.133 17.18 19.193C15.88 19.263 14.69 19.293 13.59 19.293L12 19.353C7.81 19.353 5.2 19.193 4.17 18.913C3.27 18.663 2.69 18.083 2.44 17.183C2.31 16.713 2.22 16.083 2.16 15.283C2.09 14.483 2.06 13.793 2.06 13.193L2 12.353C2 10.163 2.16 8.55303 2.44 7.52303C2.69 6.62303 3.27 6.04303 4.17 5.79303C4.64 5.66303 5.5 5.57303 6.82 5.51303C8.12 5.44303 9.31 5.41303 10.41 5.41303L12 5.35303C16.19 5.35303 18.8 5.51303 19.83 5.79303C20.73 6.04303 21.31 6.62303 21.56 7.52303Z"
        fill={color || '#999999'}
      />
    </Svg>
  )
}

export default YoutubeIcon
